import type { Route } from '!/router'
import * as root from '~/routes/epg/root'

export const route: Route = {
  children: [
    {
      path: '',
      component: [root.Title, root.EpgPage],
      init: root.model.init,
      left: root.model.left,
      meta: {
        contentId(params: { query: URLSearchParams }) {
          return Number(params.query.get('channel'))
        },
      },
    },
  ],
}
